import React, { useState } from 'react'

import { ReactComponent as IconEdit } from 'assets/images/icons/edit-3.svg'
import FormDrawer from 'components/__new/common/form-drawer'
import DateFormat from 'utils/dateFormat';
import Maybe from 'components/__new/common/Maybe';
import { frequencyDisplay } from 'utils/payroll/frequencyDisplay';
import { ViewPayrollConfigRow } from './ViewPayrollConfigRow';

const ViewPayScheduleDetails = ({isOpen, setIsOpen, paySchedule, handleTogglePayScheduleForm, loading}) => {
    const [isOpenEditPaySchedule, setIsOpenEditPaySchedule] = useState(false);
    
    const handleEditPaySchedule = () => {
        setIsOpen(false);
        handleTogglePayScheduleForm();
    }
    
    const getPaymentFrequency = () => {
        switch (paySchedule?.frequency?.payroll_frequency?.toLowerCase()) {
            case "monthly":
                return (
                    <div>
                        <div className='text-[#718096]'>Day of the Month</div>
                        <div>{paySchedule?.frequency?.day_of_month || "-"}</div>
                    </div>
                );
            case "weekly":
                return (
                    <div>
                        <div className='text-[#718096]'>Day of the Week</div>
                        <div>{paySchedule?.frequency?.day_of_week || "-"}</div>
                    </div>
                );
            default:
                return "";
        }
    }
    
    return (
        <>
            {/* <EditPaySchedule
                isOpen={isOpenEditPaySchedule}
                setIsOpen={setIsOpenEditPaySchedule}
                benefit={benefit}
            /> */}
            
            <FormDrawer display="center" size="4xl" isOpen={isOpen} setIsOpen={setIsOpen} backdropClickable={false}>
                <div className="p-6">
                    <FormDrawer.Title
                        title="Pay Schedule"
                        // description="Setup a new approval workflow"
                        showCloseButton={true}
                        close={setIsOpen}
                    />
                    <hr className='mt-3'/>

                    <div className="w-full my-7">
                        <div className="my-7 flex items-center justify-end space-x-2 cursor-pointer text-ep-primary-600"
                            onClick={handleEditPaySchedule}
                        >
                            <IconEdit />
                            <span className='underline'>Edit Information</span>
                        </div>
                        
                        <div className='p-2 rounded-xl border bg-ep-primary-light-300'>
                            <div className='font-medium text-[#374151] text-lg'>Schedule Information</div>
                            <div className='bg-white mt-4 rounded-2xl p-5 shadow-box-shadow flex flex-col gap-6'>
                                <div className="flex flex-col gap-6">
                                    <ViewPayrollConfigRow
                                        leftLabel="Schedule Name"
                                        leftValue={paySchedule?.name}
                                        rightLabel="Payroll Frequency"
                                        rightValue={frequencyDisplay(paySchedule?.frequency?.payroll_frequency)}
                                    />
                                    {
                                        paySchedule?.frequency?.payroll_frequency?.toLowerCase() === "bi_monthly" ? (
                                            <div className='flex gap-6'>
                                                <div className="flex flex-col w-3/5">
                                                    <div className='text-[#718096]'>First Run Day of the Month</div>
                                                    <div>{paySchedule?.frequency?.first_run_day || "-"}</div>
                                                </div>
                                                <div className="flex flex-col w-2/5">
                                                    <div className='text-[#718096]'>Second Run Day of the Month</div>
                                                    <div>{paySchedule?.frequency?.second_run_day || "-"}</div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='flex flex-col gap-6 w-3/5'>
                                                <>{getPaymentFrequency()}</>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </FormDrawer>
        
        </>
    )
}



export default ViewPayScheduleDetails;